import { render } from "./ConfigureCampaigns.vue?vue&type=template&id=52fe09fa"
import script from "./ConfigureCampaigns.vue?vue&type=script&lang=js"
export * from "./ConfigureCampaigns.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tamkoclarence/Desktop/projects/shoppy/firebase-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__